import { Form, Formik } from "formik";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  generateSearchFormItem,
  getTreeData,
  mapEnumToList,
} from "../../../../utils/helper";
import { SearchAccordion } from "../../../common";
import {
  defaultFilter,
  ISearchProps,
  StoredValueSourceEnum,
  StoredValueTypeEnum,
  StoredValueUnitEnum,
} from "./type";

const Search = ({ filter, data, setFilter }: ISearchProps) => {
  const { t } = useTranslation();

  return (
    <SearchAccordion>
      <Formik
        initialValues={filter}
        onSubmit={(values, { setSubmitting }) => {
          setFilter({ ...values, pages: 0 });
          setSubmitting(false);
        }}
      >
        {(form) => (
          <Form style={{ width: "100%" }}>
            {generateSearchFormItem(
              form,
              [
                {
                  type: "time",
                  name: "time",
                  label: "StoredValueRecord.time",
                },
                {
                  type: "text",
                  name: "ID",
                  label: "StoredValueRecord.ID",
                },
                {
                  type: "multiSelect",
                  name: "type",
                  label: "StoredValueRecord.type",
                  treeData: getTreeData(mapEnumToList(StoredValueTypeEnum)),
                },
                {
                  type: "text",
                  name: "playerID",
                  label: "StoredValueRecord.playerID",
                },
                {
                  type: "multiSelect",
                  name: "unit",
                  label: "StoredValueRecord.unit",
                  treeData: getTreeData(mapEnumToList(StoredValueUnitEnum)),
                },
                {
                  type: "multiSelect",
                  name: "source",
                  label: "StoredValueRecord.source",
                  treeData: getTreeData(mapEnumToList(StoredValueSourceEnum)),
                },
                {
                  type: "multiSelect",
                  name: "operator",
                  label: "StoredValueRecord.operator",
                  treeData: getTreeData(["User1", "User2"]),
                },
              ],
              defaultFilter(),
              t,
              data,
              "Stored Value Record"
            )}
          </Form>
        )}
      </Formik>
    </SearchAccordion>
  );
};

export default Search;
